import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
/**
 * moaui Styled Typography Group
 *
 * @param props - titleText, bodyText
 * @example
 * <TypographyGroup
 * 	titleText="Title"
 * 	bodyText="Body"
 * />
 * @returns JSX.Element
 */
var TypographyGroup = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
TypographyGroup.defaultProps = {
    titleText: "",
    bodyText: ""
};
var SampleProps = {};
export default TypographyGroup;
export { SampleProps as TypographyGroupSample, };
